import React from 'react'

/**
 * A headline fact in a detail modal. Detail modals never render a disabled
 * input to show a value — the three or four facts that matter become these,
 * and everything else becomes a DataRow.
 *
 * `tone` is semantic, not decorative: keep the same tone for the same kind of
 * fact across modals (primary = service, info = category, success = group,
 * warning = product).
 */
const StatCard = ({ tone = 'primary', icon, label, value, children }) => (
  <div className={`app-modal__stat app-modal__stat--${tone}`}>
    <div className='app-modal__stat-head'>
      {icon && <span className='app-modal__stat-icon'>{icon}</span>}
      <span className='app-modal__stat-key'>{label}</span>
    </div>
    {children || <p className='app-modal__stat-value'>{value || '-'}</p>}
  </div>
)

export default StatCard
